import { render, staticRenderFns } from "./ProductItemVariantDelete.vue?vue&type=template&id=76ba7a48&"
import script from "./ProductItemVariantDelete.vue?vue&type=script&lang=js&"
export * from "./ProductItemVariantDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports